import type { AgentDnaMetrics } from "./types.ts";

/**
 * Shared async-state shape and the empty headline metrics for the AgentDNA sections. The per-section
 * reads now live in `data.ts` (real `/api/v1/*` calls); this module keeps the two things both the
 * real hooks and their callers share: the `{ data, loading }` state shape, and the all-zero metrics
 * used as the fallback before the first `agent-activity` read resolves.
 */

export interface AsyncState<T> {
  readonly data: T;
  readonly loading: boolean;
}

export const EMPTY_METRICS: AgentDnaMetrics = {
  agentCount: 0,
  appCount: 0,
  intentCount: 0,
  interactionsCount: 0,
  threatCount: 0,
  avgReliability: 0,
};
